import angular from 'angular';
import $ from 'jquery';

export default class UserProductService {
  constructor($http) {
    this.$http = $http;
  }

  get_preview_data(user_product_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_product_preview',
      params: {user_product_id: user_product_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get(user_product_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_product',
      params: {user_product_id: user_product_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_combination_str(value) {
    if (typeof(value) == 'number') {
      return value;
    } else if ($.isArray(value)) {
      var result = [];
      angular.forEach(value, function(o) {
        if (typeof(o) == 'number')
          result.push(o);
        else
          result.push(o.from + ' - ' + o.to);
      });
      return result.join(', ');
    } else {
      return value.from + ' - ' + value.to;
    }
  }

  get_user_product_pricings(user_product_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_product_pricings',
      params: {user_product_id: user_product_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_products_pricings(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_products_pricings',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  save_pricings(user_product) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_pricings',
      data: {user_product: user_product, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  save_special_pricing(pricing) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_special_pricing',
      data: {pricing: pricing, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  save_special_charge(charge) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_special_charge',
      data: {charge: charge, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  save_user_product_group_charge(charge) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_user_product_group_charge',
      data: {charge: charge, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  mass_save_user_product_group_charge(charge) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/mass_save_user_product_group_charge',
      data: {charge: charge, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  mass_renew_user_product_group_charges(charges) {
    return this.$http.post(
      '/admin/marketplace/users/mass_renew_user_product_group_charges',
      {charges: charges, authenticity_token: window.token}
    );
  }

  save_target_pricing(pricing) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_target_pricing',
      data: {pricing: pricing, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_special_pricing(pricing_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_special_pricing',
      data: {pricing_id: pricing_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_special_charge(charge_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_special_charge',
      data: {charge_id: charge_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_user_product_group_charge(charge_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_user_product_group_charge',
      data: {charge_id: charge_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_target_pricing(pricing_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_target_pricing',
      data: {pricing_id: pricing_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_products_special_pricings(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_products_special_pricings',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_products_special_charges(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_products_special_charges',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_product_group_charges(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_product_group_charges',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_products_target_pricings(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_products_target_pricings',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_products_with_specs(user_id, has_reels) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_products_with_specs',
      params: {user_id: user_id, has_reels: has_reels}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_products_without_specs(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_products_without_specs',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_products_without_groups(user_id) {
    return this.$http.get(
      '/admin/marketplace/users/get_user_products_without_groups',
      {params: {user_id: user_id}}
    );
  }

  get_user_products_for_spec_groups(user_id) {
    return this.$http.get(
      '/admin/marketplace/users/get_user_products_for_spec_groups',
      {params: {user_id: user_id}}
    );
  }

  add_user_product_to_spec_group(user_id, group_id, user_product_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/add_user_product_to_spec_group',
      data: {user_id: user_id, group_id: group_id, user_product_id: user_product_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_user_product_from_spec_group(user_id, group_id, user_product_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_user_product_from_spec_group',
      data: {user_id: user_id, group_id: group_id, user_product_id: user_product_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_products(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_products',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_spec(spec_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_user_product_spec',
      data: {spec_id: spec_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_specs(user_product_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_user_product_specs',
      data: {user_product_id: user_product_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  save_mass_specs(products, specs) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_mass_specs',
      data: {products: products, specs: specs, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_specs_for_admin_view(user_product_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_specs_for_admin_view',
      params: {user_product_id: user_product_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_group_specs_for_admin_view(group_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_group_specs_for_admin_view',
      params: {group_id: group_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_multi_specs_for_admin_view(user_product_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_multi_specs_for_admin_view',
      params: {user_product_id: user_product_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_product_specs(user_product_id, filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/get_user_product_specs',
      data: {user_product_id: user_product_id, filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  sync_spec_group(group_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/sync_spec_group',
      data: {group_id: group_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  update_user_product_specs(user_product_id, specs) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/update_user_product_specs',
      data: {user_product_id: user_product_id, specs: specs, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_product_combinations(user_product_id, filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/get_user_product_combinations',
      data: {user_product_id: user_product_id, filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  update_user_product_combinations(user_product_id, combinations) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/update_user_product_combinations',
      data: {user_product_id: user_product_id, combinations: combinations, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_products_for_copy_specs(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_products_for_copy_specs',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_products_for_copy_from_user(source_user_id) {
    return this.$http.get(
      '/admin/marketplace/users/get_user_products_for_copy_from_user',
      {
        params: {
          source_user_id: source_user_id,
        }
      }
    );
  }

  copy_user_products_from_user(target_user_id, user_products, copy_mode) {
    return this.$http.post(
      '/admin/marketplace/users/copy_user_products_from_user',
      {
        target_user_id: target_user_id,
        user_products: user_products,
        copy_mode: copy_mode,
        authenticity_token: window.token,
      }
    );
  }

  copy_user_product_specs(copy) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/copy_user_product_specs',
      data: {copy: copy, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_spec_groups(user_id) {
    return this.$http.get(
      '/admin/marketplace/users/get_spec_groups',
      {params: {user_id: user_id}}
    );
  }

  create_spec_group(user_id, title) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/create_spec_group',
      data: {user_id: user_id, title: title, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  update_target_pricings_from_last_order(user_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/update_target_pricings_from_last_order',
      data: {user_id: user_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_product_group_specs(product_group_ids, is_reels) {
    return this.$http.post(
      '/admin/marketplace/users/get_product_group_specs',
      {product_group_ids: product_group_ids, is_reels: is_reels, authenticity_token: window.token}
    );
  }

  get_product_group_settings(user_id) {
    return this.$http.get('/admin/marketplace/users/get_product_group_settings/' + user_id);
  }

  update_product_group_settings(user_id, product_group_id, settings) {
    return this.$http.post(
      '/admin/marketplace/users/update_product_group_settings',
      {user_id: user_id, product_group_id: product_group_id, settings: settings, authenticity_token: window.token}
    );
  }

  update_spec_group(spec_group) {
    return this.$http.post(
      '/admin/marketplace/users/update_spec_group',
      {spec_group: spec_group, authenticity_token: window.token}
    );
  }

  update_spec_group_products(user_id, product_group_id) {
    return this.$http.post(
      '/admin/marketplace/users/update_spec_group_products',
      {user_id: user_id, product_group_id: product_group_id, authenticity_token: window.token}
    );
  }
}

UserProductService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/user-product.service.js